import { mortgageSliders, mortgageShowMore, developerControll } from './components/misc';
import complexLotLogic from './complexLotLogic';

const lotShow = {
    init: function () {
        document.addEventListener('DOMContentLoaded', () => {
            this.lotsSlider();
            this.lotsFinishingSlider();
            mortgageSliders();
            mortgageShowMore();
            developerControll();
        });
    },
    lotsSlider: function() {
        if ($('.lots-main__gallery-slider').length == 0) return;

        $('.lots-main__gallery-slider').each(function() {
            let thisSlider = $(this);
            let container = $('.lots-main__scene');
            let lotGallery = thisSlider.flickity({
                pageDots: false,
                prevNextButtons: false,
                cellAlign: 'left',
                contain: true,
                wrapAround: true
            });

            let lotGalleryData = lotGallery.data('flickity');

            function updateStatus() {
                let slideNumber = lotGalleryData.selectedIndex + 1,
                    typeImage = $(lotGalleryData.selectedCell.element).data('type-image'),
                    darkModeTypes = ['flat', 'floor'];

                if (lotGalleryData.slides.length !== 1) {
                    container.find('.lots-main__gallery-counter').addClass('show');
                    container.find('.lots-main__gallery-buttons').addClass('show');
                }

                thisSlider.siblings('.lots-main__gallery-counter').text(slideNumber + '/' + lotGalleryData.slides.length);

                $(`[name="lot-flats"][value="${typeImage}"]`).prop('checked', true);

                if (darkModeTypes.includes(typeImage)) {
                    thisSlider.closest('.lots-main__gallery').addClass('lots-main__gallery_dark');
                } else {
                    thisSlider.closest('.lots-main__gallery').removeClass('lots-main__gallery_dark');
                }
            }
            updateStatus();

            lotGallery.on('select.flickity', updateStatus);

            lotGallery.on('staticClick.flickity', function(event) {
                if ($(window).width() > 767) {
                    openModalGallery(thisSlider, event);
                }
            });
            lotGallery.on('click', function(event) {
                if ($(window).width() < 768) {
                    openModalGallery(thisSlider, event);
                }
            });

            $(this).siblings('.lots-main__gallery-buttons').on('click', '.lots-main__gallery-btn', function() {
                switch (true) {
                    case $(this).hasClass('lots-main__gallery-btn_left'):
                        lotGallery.flickity('previous');
                        break;
                    case $(this).hasClass('lots-main__gallery-btn_right'):
                        lotGallery.flickity('next');
                        break;
                }

                thisSlider.trigger('focus');
            });

            $('.lots-main__switcher input').on('change', function() {
                let index = thisSlider.find($(`[data-type-image="${$(this).val()}"]`)).first().index();
                lotGallery.flickity('selectCell', index);
            });
        });

        function openModalGallery(slider, e) {
            let itemCounter = 1,
                imagesGallery = $('.lots-main__scene').find('img'),
                galleryWrapp = $('#gallery-lot .modal__gallery-grid'),
                currentImageType = e.target.closest('[data-type-image]').getAttribute('data-type-image'),
                currentItem = e.target.closest('.lots-main__gallery-item'),
                targetItem = null,
                imagesArr = slider.find('img, svg');

            galleryWrapp.html('');

            imagesArr.each(function(i, el) {
                let captureWrapp = itemCounter % 3 == 0 ? '<div class="modal__capture-wrapp"></div>' : '',
                    innerTag = null;

                if (el.nodeName == 'IMG') {
                    innerTag = `<img class="fast_background" data-url="${$(el).data('url')}" / >`;
                } else if (el.nodeName == 'svg') {
                    innerTag = el.outerHTML;
                }

                galleryWrapp.append(`
                    <div class="modal__gallery-item" data-type="${$(el).closest('.lots-main__gallery-item').data('type-image')}" data-index="${i}">
                        ${innerTag}
                    </div>
                    ${captureWrapp}
                `);

                if (imagesGallery.length == itemCounter && imagesGallery.length % 3 !== 0) {
                    galleryWrapp.append(captureWrapp);
                } else {
                    itemCounter++;
                }
            });

            popupActions.galleryPopup('#gallery-lot');
            popupActions.popupShow('gallery-lot');
            fast_background.update();

            if ($(currentItem).index() == 0) return;

            if (currentImageType == 'gallery') {
                targetItem = $(`.modal__gallery-item[data-index="${$(currentItem).index()}"]`);
            } else {
                targetItem = $(`.modal__gallery-item[data-type="${currentImageType}"]`).first();
            }

            let scrollTarget = targetItem.position().top + parseInt($('.modal__gallery').css('margin-top'));
            $('.modal_gallery').animate({scrollTop: scrollTarget}, 0);

        }
    },

    lotsFinishingSlider: function() {
        let infinitySlider = null,
            sliders = $('.finishing__slider');

        if ($(window).width() > 767) {
            sliders.each(function(index, slider) {
                let finishingLotSlider = $(slider).flickity({
                    pageDots: false,
                    prevNextButtons: false,
                    wrapAround: true,
                    cellAlign: 'center',
                });

                $(slider).closest('.finishing__container').on('click', '.lots-main__gallery-btn', function() {
                    switch (true) {
                        case $(this).hasClass('lots-main__gallery-btn_left'):
                            finishingLotSlider.flickity('previous');
                            break;
                            case $(this).hasClass('lots-main__gallery-btn_right'):
                            finishingLotSlider.flickity('next');
                            break;
                    }
                });

                if (finishingLotSlider.data('flickity').slides.length !== 1) {
                    $(slider).closest('.finishing__container').find('.lots-main__gallery-buttons').addClass('show');
                }
            });
        }
    },
}

lotShow.init();